import { render } from "./DepositPage.vue?vue&type=template&id=7e18ba9c&scoped=true"
import script from "./DepositPage.vue?vue&type=script&lang=js"
export * from "./DepositPage.vue?vue&type=script&lang=js"

import "./DepositPage.vue?vue&type=style&index=0&id=7e18ba9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e18ba9c"]])

export default __exports__